import {
  setIsCertificateInstancesRequested,
  setIsUsersRequested,
} from '../../../Store/DataSlice'
import './UserDetail.scss'
import { useEffect, useState } from 'react'
import { useLocalization } from '../../../Hooks/useLocalization'
import { useDispatch, useSelector } from 'react-redux'
import { type RootState } from '../../../Store/Store'
import { Button } from '../../../Components/Button/Button'
import { getAuthorizationHeader } from '../../../Orchestration/Authentication'
import { setDestinationView } from '../../../Store/InterfaceSlice'

interface UserDetailProps {
  email: string
}
export function UserDetail({ email }: UserDetailProps) {
  const dispatch = useDispatch()
  const localization = useLocalization('user')

  const isUsersRequested = useSelector(
    (state: RootState) => state.data.isUsersRequested
  )
  useEffect(() => {
    if (!isUsersRequested) dispatch(setIsUsersRequested(true))
  }, [isUsersRequested, dispatch])

  const isCertificateInstancesRequested = useSelector(
    (state: RootState) => state.data.isCertificateInstancesRequested
  )
  useEffect(() => {
    if (!isCertificateInstancesRequested)
      dispatch(setIsCertificateInstancesRequested(true))
  }, [isCertificateInstancesRequested, dispatch])

  const allCertificateInstances = useSelector(
    (state: RootState) => state.data.certificateInstances
  )

  const user = useSelector((state: RootState) =>
    state.data.users.find((c) => c.email === email)
  )

  const [deleteInProgress, setDeleteInProgress] = useState(false)
  const deleteUser = () => {
    if (
      user?.email != null &&
      window.confirm(
        localization.text(
          'delete-user-prompt',
          'Ben je zeker dat je deze gebruiker permanent wilt verwijderen?'
        )
      )
    ) {
      setDeleteInProgress(true)
      fetch(
        `https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/user-remove`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...getAuthorizationHeader(),
          },
          body: JSON.stringify({
            email: user.email,
          }),
        }
      )
        .then(() => {
          dispatch(setIsUsersRequested(false))
          setTimeout(() => {
            dispatch(setDestinationView({ destinationView: 'user-list' }))
          }, 1)
        })
        .catch((err) => {
          console.warn(`fetch company-add failed: `, err)
        })
    }
  }

  return (
    <div className="user-detail">
      {deleteInProgress ? (
        <div className="delete-in-progress">
          {localization.text(
            'user-delete-in-progress',
            'De gebruiker word momenteel verwijderd.'
          )}
        </div>
      ) : !user ? (
        <div className="loading">
          {localization.text(
            'user-is-loading',
            'De gebruiker word momenteel ingeladen.'
          )}
        </div>
      ) : (
        <>
          <div className="display-field">
            <div className="display-label">
              {localization.text('email', 'Email')}
            </div>
            <div className="display-value">{user.email}</div>
          </div>
          <div className="display-field">
            <div className="display-label">
              {localization.text('is-admin', 'Is administrator')}
            </div>
            <div className="display-value">{user.isAdmin ? '✔️' : '❌'}</div>
          </div>
          <div className="display-field">
            <div className="display-label">
              {localization.text(
                'certificate-instance',
                'Certificaat instantie'
              )}
            </div>
            <div className="display-value">
              {user.certificateInstanceVatNumber != null
                ? allCertificateInstances.find(
                    (ci) => ci.vatNumber === user.certificateInstanceVatNumber
                  )?.name ?? ''
                : ''}
            </div>
          </div>

          <div className="buttons">
            <Button
              importance={'danger'}
              text={localization.text('remove-button', 'Verwijder gebruiker')}
              onClick={deleteUser}
            />
          </div>
        </>
      )}
    </div>
  )
}
